import React, {Fragment, useMemo} from "react";
import { Col, Row } from "antd";
import { observer } from "mobx-react";
import {IDepartmentsSummary} from "../../../declarants/Interfaces";
import {Rounded} from "../../../../helpers/round";
import {DepartmentSummaryField, departmentSummaryFields} from "../../../../models/DepartmentData/DepartmentSummary";
import LoadingIcon from "antd/es/button/LoadingIcon";
import {Nullable} from "../../../../models/Common";

interface Props {
  store: IDepartmentsSummary;
  gutter: number;
}

const DepartmentsSummary: React.FC<Props> = ({ store, gutter }) => {
  const columns: DepartmentSummaryField[] = useMemo(() => {
    const orderMap: Map<DepartmentSummaryField, number> = new Map<DepartmentSummaryField, number>(departmentSummaryFields.map((value, index) => [value, index]));
    const summaryFields = Object.keys(store.summary);
    let selectedSummaryFields = Object.keys(store.selectedSummary);
    selectedSummaryFields = selectedSummaryFields.filter(field => !summaryFields.includes(field));
    const allFields = summaryFields.concat(selectedSummaryFields) as DepartmentSummaryField[];
    allFields.sort((a, b) => {
      const aIndex: Nullable<number> = orderMap.get(a);
      const bIndex: Nullable<number> = orderMap.get(b);
      const aOrdered: boolean = aIndex !== undefined;
      const bOrdered: boolean = bIndex !== undefined;
      if (!aOrdered && !bOrdered) return 0;
      if (!aOrdered) return -1;
      if (!bOrdered) return 1;
      return (aIndex as number) - (bIndex as number);
    });

    return allFields;
  }, [store.selectedSummary, store.summary]);

  return (
    <Col
      style={{
        position: 'relative',
      }}
    >
      { store.summaryLoading && (
        <div
          style={{
            zIndex: 10,
            paddingTop: 8,
          }}
          className={'stretch-over full-center dim-behind-white'}
        >
          <LoadingIcon prefixCls={''} existIcon />
        </div>
      )}
      <Row gutter={gutter}>
        { columns.map(field => (
          <Fragment key={field}>
            <Col>
              <div className="summary">
                <p>{store.summary[field]?.title || ''}</p>
                <p>{Rounded.of(store.summary[field]?.value ?? 0, 2).value}</p>
              </div>
              <div className="summary">
                <p>{Rounded.of(store.selectedSummary[field]?.value ?? 0, 2).value}</p>
              </div>
            </Col>
          </Fragment>
        )) }
      </Row>
    </Col>
  );
};

export default observer(DepartmentsSummary);
